export default "__VITE_ASSET__D6Ga21p2__"